import dedent from 'dedent';
import { z } from 'zod';
import { FIRST_VERSION_TIMESTAMP, coerceLiteralNumberRequired, zodTDateISODate } from '~/lib/zod';
import { layoutSchema } from '~/tenants/bre/performable/print/design/BreDesignConfig';
import { TenantId, createPerformableConfig } from '~/tenants/common/registry';

export type PostcardPrintOnlyCount = z.infer<typeof countSchema>;

export const countSchema = z.enum([
  '50',
  '100',
  '200',
  '250',
  '500',
]);

export default createPerformableConfig(
  'postcards-printonly',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      count: countSchema,
      need_by: zodTDateISODate('Need By date is required'),
      design: layoutSchema.optional(),
    }),
  },
  {
    name: 'Post Cards (print-only)',
    group: 'Property Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/print/postcards/printonly/thumbnail.jpg',
    images: [],
    short: dedent`
      Our custom postcards are perfect for marketing listings and engaging your community. \
      Whether it's Just Listed, Just Sold, or another announcement, we create eye-catching \
      designs tailored to your brand. Available in half-sheet (5.5" x 8.5") or jumbo (6" x 11") \
      sizes, we provide high-resolution, print-ready files for flexible printing and mailing.
    `,
  },
);
